export const tokens = {
    labelSize: 14,
    borderSize: 1,
    optionSize: 40,
    iconSize: 14,
};
